export enum CheckResetTokenStatus {
  Invalid = "invalid",
  Valid = "valid"
}

export interface ICheckResetTokenResponseBody {
  response: CheckResetTokenStatus;
}

export interface ILogInResponseBody {
  account: {
    accountId: string;
    termsAcceptedBy: string | null;
    webName: string;
  };
  api: string;
  nonce: string[];
  stok: string;
  userId: string;
}
